import React from 'react';
import ReactDOM from 'react-dom';
import {Link, withRouter} from 'react-router';

import {
  Row,
  Col,
  Icon,
  Grid,
  Panel,
  Table,
  PanelBody,
  PanelHeader,
  FormControl,
  PanelContainer,
  FormGroup,
  ControlLabel,
  Form,
  Well,
  InputGroup,
  Button,
  ButtonGroup,
  ButtonToolbar,
  MenuItem,
  DropdownButton,
} from '@sketchpixy/rubix';

import Loader from 'react-loader';
import {
    getMessageCodes,
    deleteMessageCode,
    getAccessToken
} from '../../api/api';
import ServiceType from '../../constants/ServiceType';
import UploadBulkMessageModal from './components/UploadBulkMessageModal';
import {routeUrl} from '../routeUrl';
import {
    downloadBulkTemplate,
    downloadSearchTemplate
} from '../../api/url';

export default class MultilingualMgnt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: true,
      showUploadMessageModal: false,
      search: {
          searchType: '',
          searchWord: '',
          serviceType: ''
      }
    };
  }

  listTable = null;

  componentDidMount() {
  }

  doSearch = (search) => {
      this.listTable.doSearch(search);
  }

  onSearchChanged = (search) => {
      this.setState({
          search
      });
  }

  addMessage = (evt) => {
     this.props.router.push(`${routeUrl.multilingualDetail}`);
  }



  uploadMessage = (evt) => {
	  this.setState({
		  showUploadMessageModal: true,
      });
  }

  downloadMessage = (evt) => {
      let accessToken = getAccessToken();
      document.location.href = `${downloadBulkTemplate}?access_token=${accessToken}`
  }

  downloadMessageWithSearchResult = (evt) => {
    let accessToken = getAccessToken();

    var search= {...this.state.search}

    document.location.href = `${downloadSearchTemplate}?access_token=${accessToken}&searchType=${search.searchType}&searchWord=${search.searchWord}&serviceType=${search.serviceType}`
  }



  closeUploadMessageModal = (evt) => {
	  this.setState({
		  showUploadMessageModal: false,
      });
  }


  editMessage = (messageCodeId) => {
         this.props.router.push(`${routeUrl.multilingualDetail}/${messageCodeId}`);
      }

      deleteMessage = (messageCodeId) => {
        let self = this;
         vex.dialog.confirm({
            message: 'Are you sure to delete this item?',
            callback: function (value) {
                if (value) {
                     deleteMessageCode(messageCodeId, (err, res) => {
                        if (err) {
                            vex.dialog.alert('Failed to delete message!');
                          } else {
                            vex.dialog.alert('Message Deleted!');
                            self.doSearch();
                          }
                    });
                } else {
                    console.log('delete cancel')
                }
            }
        });
   }


  render() {
    return (
      <Grid>
          <Row>
            <Col sm={12}>
              <PanelContainer controls={false}>
                <Panel>
                  <PanelHeader className="bg-pinkishred fg-white">
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <h3>
                            Multilingual Management
                          </h3>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelHeader>
                  <PanelBody style={{padding: 25}}>
                  <Grid>
                <Row>
                  <Col xs={12}>
                  <MultilingualSearchForm  doSearch={this.doSearch} searchChangehandler={this.onSearchChanged}></MultilingualSearchForm>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}  className='text-right'>
                    <ButtonToolbar className='inbox-toolbar'>
                      <ButtonGroup>
                        <Button bsStyle='info' onClick={this.addMessage}><Icon glyph='icon-fontello-doc-new'/></Button>
                        <Button bsStyle='info' onClick={this.uploadMessage}><Icon glyph='icon-fontello-upload' alt="Upload Bulk Template"/></Button>
                        <Button bsStyle='info' onClick={this.downloadMessage}><Icon glyph='icon-fontello-download' alt="Download Bulk Template"/></Button>
                        <Button bsStyle='info' onClick={this.downloadMessageWithSearchResult}><Icon glyph='icon-fontello-download-cloud' alt="Download Bulk Template with Search Result"/></Button>
                      </ButtonGroup>
                    </ButtonToolbar>
                    </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <MultilingualListTable   ref={(ref) => this.listTable = ref} editMessage={this.editMessage} deleteMessage={this.deleteMessage}/>
                    <br />
                  </Col>
                </Row>
              </Grid>
                  </PanelBody>
                </Panel>
              </PanelContainer>
            </Col>
          </Row>
          <Loader loaded={this.state.loaded} />
          <UploadBulkMessageModal
          showModal={this.state.showUploadMessageModal}
          closeModal={this.closeUploadMessageModal}
          />
        </Grid>
    );
  }
}

class MultilingualSearchForm extends React.Component {
   constructor(props) {
    super(props);

    this.state = {
      search: {
        searchType: '',
        searchWord: '',
        serviceType: '',
      }
    };


    this.doSearch = this.doSearch.bind(this);
    this.searchWordChange = this.searchWordChange.bind(this);
  }

  serviceTypeChangeHandler = (event) => {
    var search= {...this.state.search}
    search.serviceType = event.target.value;
    this.setState({
      search: search,
    }, () => {
    });

    this.props.searchChangehandler(search)

  }

  searchTypeChangeHandler = (eventKey,event) => {
    let text = $(event.target.parentElement).text();
    $('#search-type-dropdown').text(text);

    var search= {...this.state.search}
    search.searchType = event.target.getAttribute('value');

    this.setState({
      search: search
    }, () => {
    });

      this.props.searchChangehandler(search)
  }

  searchWordChange (e) {
    var search= {...this.state.search}
    search.searchWord = e.target.value;
    this.setState({ search: search});

    this.props.searchChangehandler(search)
  }

  doSearch (event) {
    event.preventDefault();
    this.props.doSearch(this.state.search);
  }

  componentDidMount() {

  }

  render() {
    return (
      <Well>
          <Form horizontal onSubmit={this.doSearch}>
              <FormGroup controlId="serviceTypeSelect">
                  <Col componentClass={ControlLabel} sm={2}>Service Type</Col>
                  <Col sm={10}>
                      <FormControl
                        componentClass="select"
                        onChange={this.serviceTypeChangeHandler}
                        value={this.state.search.serviceType}
                        >
                        <option value="">ALL</option>
                        <option key='COMMON' value={null}>Common</option>
                        {
                            ServiceType.enumValues.map(serviveType => (
                                <option key={serviveType.name} value={serviveType.name}>{serviveType.title}</option>
                            ))
                        }
                      </FormControl>
                  </Col>
              </FormGroup>
              <FormGroup controlId='searchWord'>
                      <Col sm={2} componentClass={ControlLabel}>Search Word</Col>
                      <Col sm={10}>
                          <InputGroup>
                              <DropdownButton
                                  componentClass={InputGroup.Button}
                                  id="search-type-dropdown"
                                  title="Search Type"
                                  value={this.state.search.searchType}
                                  onSelect={this.searchTypeChangeHandler}
                                  bsStyle='primary'>
                                  <MenuItem value="" active>Search Type</MenuItem>
                                  <MenuItem value="CODE">Message Code</MenuItem>
                                  <MenuItem value="WRITER">Writer</MenuItem>
                              </DropdownButton>
                              <FormControl type='text' placeholder='Search Word' onChange={this.searchWordChange}/>
                              <InputGroup.Button>
                                <Button  onClick={this.doSearch}>Search</Button>
                              </InputGroup.Button>
                          </InputGroup>
                      </Col>
              </FormGroup>
        </Form>
      </Well>
    );
  }
}

class MultilingualListTable extends React.Component {
   constructor(props) {
    super(props);

    this.state = {
      loaded: true,
      search: {},
      datatables: null,
    };
  }

   editMessage = (messageCodeId) => {
       this.props.editMessage(messageCodeId);
   }

    deleteMessage = (messageCodeId) => {
          this.props.deleteMessage(messageCodeId);
   }

   componentDidMount() {
    let self = this;
    let datatableDom = $(ReactDOM.findDOMNode(this.refs.datatables));

    let datatables = datatableDom.addClass('nowrap')
      .DataTable({
        language: { infoFiltered: "" },
        processing: true,
        serverSide: true,
        responsive: true,
        searchDelay: 2000,
        searching: false,
        ajax : function (data, callback, settings) {
           let search = self.state.search;
           let param =_.merge({}, data, search)

           getMessageCodes(param, (err, res) => {
             callback(res.result);
           });
        },
        columns: [
            {
              name: 'messageCode',
              data: 'messageCode',
              defaultContent : ""
            },
            {
                name: 'serviceTypeName',
                data: 'serviceTypeName',
                defaultContent : ""
            },
            {
                name: 'adminUserName',
                data: 'adminUserDto.adminUserName',
                defaultContent : ""
              },
            {
              name: 'updatedTime',
              data: 'updatedTime',
              defaultContent : "",
              render: function (d, type, row) {
                let m = moment(d);
                return m.isValid() ? m.format('MMMM Do YYYY, h:mm:ss a') : '';
               }
            },
            {
              name: 'actions',
              data: 'messageCodeId',
              defaultContent : "",
              render: function (messageCodeId, type, row) {
                let buttons = '';
                buttons +="<Button class='btn btn-info edit_messate_text_btn'  data-id='"+messageCodeId+"' data-action='EDIT'>Edit</Button>"; //수정
                buttons +="<Button class='btn btn-danger delete_messate_text_btn' data-id='"+messageCodeId+"' data-action='DELETE'>Delete</Button>" //Delete

                return buttons;
              }
            },
        ],
        rowId: 'messageTextId',
        select: true,
    });


    datatableDom.find('tbody').on('click', 'button',  function (event) {
      let messageCodeId = $(event.target).data("id");
      let action = $(event.target).data("action");
      switch(action)
      {
        case 'EDIT':
          self.editMessage(messageCodeId);
          break;
        case 'DELETE':
          self.deleteMessage(messageCodeId);
          break;
      }
    });

    this.setState({datatables: datatables});
  }

  doSearch = (search) => {
    this.setState({search: search}, () => {
        this.state.datatables.ajax.reload();
    });
  }


  render() {
    return (
      <Table ref="datatables" className='display' cellSpacing='0' width='100%'>
        <thead>
          <tr>
            <th>Message Code</th>
            <th>Service Type</th>
            <th>Writer</th>
            <th>Modified Date</th>
            <th>Actions</th>
          </tr>
        </thead>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/MultilingualMgnt/MultilingualMgnt.js